import { render, staticRenderFns } from "./SetLanguageValue.vue?vue&type=template&id=580c0286"
import script from "./SetLanguageValue.vue?vue&type=script&lang=js"
export * from "./SetLanguageValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports